import { HStack, Pressable, VStack } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { MenuActionItemProps } from "./types";
import { Text } from "@repo/core/components/core/Text";
import { MustShow } from "@repo/core/components/core/MustShow";

export const MenuActionItem = ({
  title,
  description,
  leftIcon,
  onPress,
  isVisible = true,
  borderWidth = 2
}: MenuActionItemProps) => {
  return (
    <MustShow isVisible={isVisible}>
      <Pressable
        flexDirection="row"
        h="$16"
        p="$4"
        gap={8}
        alignItems="center"
        borderWidth={borderWidth}
        borderColor="$borderLight200"
        borderRadius="$lg"
        bg="$backgroundDark0"
        onPress={onPress}
      >
        <HStack flex={1} gap="$2" alignItems="center">
          {leftIcon && <Icon name={leftIcon} size={22} color="$primary700" />}
          <VStack flex={1}>
            <Text fontWeight={500} color="$secondary700" lineHeight={20}>
              {title}
            </Text>
            <Text
              fontWeight={400}
              fontSize="$xs"
              color="$secondary400"
              lineHeight={20}
            >
              {description}
            </Text>
          </VStack>
        </HStack>
        <Icon name="chevron-right" size={20} color="$secondary700" />
      </Pressable>
    </MustShow>
  );
};
